import React, { Suspense, useEffect } from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './i18n' // Initialize i18n
import './style.css'
import Home from './views/home'
import Gallery from './views/gallery'
import OrderSuccess from './views/order-success'
import PrivacyPolicy from './views/privacy-policy'
import CGV from './views/cgv'
import MentionsLegales from './views/mentions-legales'
import About from './views/about'
import Contact from './views/contact'
import NotFound from './views/not-found'
import analytics from './services/analytics'

// Initialize analytics with Amplitude API key
// Replace 'YOUR_AMPLITUDE_API_KEY' with actual key in production
const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY || ''

const App = () => {
  // Initialize analytics on app mount
  useEffect(() => {
    if (AMPLITUDE_API_KEY) {
      analytics.init(AMPLITUDE_API_KEY)
    } else {
      console.log('[Analytics] No API key provided, running in debug mode')
    }
  }, [])

  return (
    <Suspense fallback={<div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>}>
      <Router>
        <Switch>
          <Route component={Home} exact path="/" />
          <Route component={Gallery} exact path="/gallery" />
          <Route component={OrderSuccess} exact path="/order-success" />
          <Route component={PrivacyPolicy} exact path="/privacy-policy" />
          <Route component={CGV} exact path="/cgv" />
          <Route component={MentionsLegales} exact path="/mentions-legales" />
          <Route component={About} exact path="/about" />
          <Route component={Contact} exact path="/contact" />
          <Route component={NotFound} path="**" />
          <Redirect to="**" />
        </Switch>
      </Router>
    </Suspense>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
